import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { GroupFilter } from '@app/core/_models'
import { UtilsService } from '@app/core/_services'
import { GroupFilterService } from '@app/core/_services/group-filter.service'
import { LocalStorageAccessService } from '@app/core/_services/local-storage-access.service'
import { UserService } from '@app/core/_services/user.service'
import { ButtonModule } from 'primeng/button'
import { CheckboxChangeEvent, CheckboxModule } from 'primeng/checkbox'

import { Subject, takeUntil } from 'rxjs'

@Component({
    selector: 'fm-group-filter',
    imports: [ButtonModule, CheckboxModule, FormsModule],
    templateUrl: './group-filter.component.html',
    styleUrl: './group-filter.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupFilterComponent {
    @ViewChild('container') container: ElementRef<HTMLElement>

    private ngUnsubscribe: Subject<any> = new Subject<any>()
    public groupFilters: GroupFilter[] = []
    public groupPanelExpanded: boolean

    constructor(
        private groupFilterService: GroupFilterService,
        private userService: UserService,
        private localStorageAccessService: LocalStorageAccessService,
        private utilsService: UtilsService,
    ) {}

    ngOnInit(): void {
        const panelOpen = this.localStorageAccessService.getItem('groupSidebar:openPanel')
        this.groupPanelExpanded = panelOpen === 'true'
        this.groupPanelExpanded = false

        this.userService.currentUser.pipe(takeUntil(this.ngUnsubscribe)).subscribe((user) => {
            this.groupFilters.length = 0
            this.groupFilters = this.groupFilterService.initGroupFilters(user.group)
        })
    }

    onClickTogglePanel(): void {
        this.utilsService.animateHeightChange(this.container.nativeElement, () => {
            this.groupPanelExpanded = !this.groupPanelExpanded
        })

        this.localStorageAccessService.setItem(
            'groupSidebar:openPanel',
            this.groupPanelExpanded.toString(),
        )
    }

    onCheckboxChanged(e: CheckboxChangeEvent): void {
        this.groupFilters.forEach((filter) => {
            this.groupFilterService.updateFilter(filter.groupInfo.groupId, filter.show)
        })
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(null)
        this.ngUnsubscribe.complete()
    }
}
